module.exports = __webpack_public_path__ + "static/media/dmp-tab-sm.e210da2b.svg";